import { render } from "./DiarySetting.vue?vue&type=template&id=60ee1fe3&ts=true"
import script from "./DiarySetting.vue?vue&type=script&lang=ts"
export * from "./DiarySetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__